var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhiteRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#EFEFEF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.65,
  d: "M19.998 8l11.87 22.667c.35.666 0 1.333-.697 1.333h-7.682c-.233 0-1.396 0-1.978-1.111l-1.285-2.454a1.997 1.997 0 01-.228-.927V8z",
  fill: "#58B0DC"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.825 32h7.681c.233 0 1.397 0 1.979-1.111l1.285-2.454c.15-.286.228-.604.228-.927V8L8.127 30.667c-.35.666 0 1.333.698 1.333z",
  fill: "#0289CC"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiNFRkVGRUYiLz4KPHBhdGggb3BhY2l0eT0iMC42NSIgZD0iTTE5Ljk5NzggOEwzMS44Njg3IDMwLjY2NjdDMzIuMjE3OCAzMS4zMzMzIDMxLjg2ODcgMzIgMzEuMTcwNSAzMkgyMy40ODkyQzIzLjI1NjUgMzIgMjIuMDkyNiAzMiAyMS41MTA4IDMwLjg4ODlMMjAuMjI1OCAyOC40MzUzQzIwLjA3NTkgMjguMTQ5MSAxOS45OTc4IDI3LjgzMTMgMTkuOTk3OCAyNy41MDgzVjhaIiBmaWxsPSIjNThCMERDIi8+CjxwYXRoIGQ9Ik04LjgyNTI1IDMySDE2LjUwNjRDMTYuNzM5MiAzMiAxNy45MDMgMzIgMTguNDg0OSAzMC44ODg5TDE5Ljc2OTkgMjguNDM1M0MxOS45MTk4IDI4LjE0OTEgMTkuOTk3OSAyNy44MzEzIDE5Ljk5NzkgMjcuNTA4M1Y4TDguMTI2OTcgMzAuNjY2N0M3Ljc3NzgxIDMxLjMzMzMgOC4xMjY5NiAzMiA4LjgyNTI1IDMyWiIgZmlsbD0iIzAyODlDQyIvPgo8L3N2Zz4K";
export { SvgWhiteRounded as ReactComponent };